module.exports = __webpack_public_path__ + "img/temp.888eec46.png";